import { useEffect } from 'react'

export const usePreventWindowFileDrop = () => {
  useEffect(() => {
    const preventFileOpen = (event: DragEvent) => {
      if (event.dataTransfer?.types.includes('Files')) {
        event.preventDefault()
      }
    }
    window.addEventListener('dragover', preventFileOpen)
    window.addEventListener('drop', preventFileOpen)
    return () => {
      window.removeEventListener('dragover', preventFileOpen)
      window.removeEventListener('drop', preventFileOpen)
    }
  }, [])
}
